import React from "react";
import { Button as MuiButton } from "@mui/material";
import { VEHICLE_TYPE_OPTIONS } from "../../utils/mapNevdisBodyType";
import { formatMoney, resolveSignupLinkPrices } from "../../utils/signupLinkPrice";

const Button = ({ handleClick}) => (
  <MuiButton variant="contained" onClick={handleClick} color={"primary"}>
    {"View Sign Up Link"}
  </MuiButton>
);

const vehicleTypeLabel = (vehicleType) => {
  if (!vehicleType) return null;
  return (
    VEHICLE_TYPE_OPTIONS.find((o) => o.value === String(vehicleType).toLowerCase())
      ?.label || String(vehicleType)
  );
};

const SelfSignUpCard = ({ product, handleClick, partnerProducts }) => {
    const productName = product?.idProduct?.name
      ? product.idProduct.name
      : product?.idSubscription?.name || "Unknown product";
    const variantLabel = vehicleTypeLabel(product?.vehicleType);
    const displayTitle = product?.linkLabel || productName;
    const { effectivePrice, priceOverride } = resolveSignupLinkPrices(product, partnerProducts);
    const effectiveLabel = formatMoney(effectivePrice);

    return (
      <div
        className={`flex flex-column p-4 w-[250px] min-h-[350px] justify-between items-center shadow box-border border product-card`}
      >
        <div className="flex flex-col w-full">
          <p>{product?.idProduct ? "Product" : "Subscription"}</p>
          <h5 className="font-bold">{displayTitle}</h5>
          {product?.linkLabel && productName !== displayTitle ? (
            <p className="text-xs text-gray-500 mt-1">{productName}</p>
          ) : null}
          {variantLabel ? (
            <p className="text-sm font-medium text-slate-700 mt-1">{variantLabel}</p>
          ) : null}
        </div>
        <p className="">{product.idUser ? product.idUser.firstName + " " + product.idUser.lastName : "No User"}</p>
        <p className="">${Number(product.rrp || 0).toFixed(2)}</p>
        {effectiveLabel ? (
          <p className="text-sm text-gray-600">
            Product price: ${effectiveLabel}
            {priceOverride != null ? " (custom)" : ""}
          </p>
        ) : null}
        <p className="text-sm text-gray-600">
          {product.lockInPeriodMonths != null
            ? `${product.lockInPeriodMonths}-month lock-in`
            : "No lock-in"}
        </p>
        <p className="text-sm text-gray-600">
          {product.paidMonthly ||
          (product.lockInPeriodMonths != null &&
            Number(product.lockInPeriodMonths) < 12)
            ? "Paid monthly"
            : "Product billing"}
        </p>
        <Button handleClick={handleClick} />
      </div>
    );
};

export default SelfSignUpCard;
